function getMfaBaseUrl() {
  const apiUrl = process.env.REACT_APP_API_URL || '';
  const kongBase = apiUrl.replace(/\/triage-backend\/?$/, '');
  return `${kongBase}/rpm-service/v2/mfa`;
}

async function mfaFetch(token, path, options = {}) {
  return fetch(`${getMfaBaseUrl()}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
}

export async function getMfaStatus(token) {
  const res = await mfaFetch(token, '/status');
  if (!res.ok) {
    const err = new Error(`getMfaStatus failed: ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export async function requestMfaChallenge(token) {
  const res = await mfaFetch(token, '/challenge', { method: 'POST' });
  if (!res.ok) throw new Error(`${res.status}`);
}

export async function verifyMfa(token, code, method) {
  const res = await mfaFetch(token, '/verify', {
    method: 'POST',
    body: JSON.stringify({ code, ...(method ? { method } : {}) }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.code || 'VERIFY_FAILED');
    err.status = res.status;
    err.code = body.code;
    err.attemptsRemaining = body.attemptsRemaining;
    throw err;
  }
}

export async function useBackupCode(token, code) {
  const res = await mfaFetch(token, '/backup', {
    method: 'POST',
    body: JSON.stringify({ code }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.code || 'BACKUP_FAILED');
    err.status = res.status;
    err.code = body.code;
    throw err;
  }
}

export async function initiateMfaSetup(token, method) {
  const res = await mfaFetch(token, '/setup', {
    method: 'POST',
    body: JSON.stringify({ method }),
  });
  if (!res.ok) {
    const err = new Error(`${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export async function verifyMfaSetup(token, code) {
  const res = await mfaFetch(token, '/verify-setup', {
    method: 'POST',
    body: JSON.stringify({ code }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.code || 'SETUP_VERIFY_FAILED');
    err.status = res.status;
    err.code = body.code;
    throw err;
  }
  return res.json();
}

export async function invalidateMfaSession(token) {
  await mfaFetch(token, '/session', { method: 'DELETE' });
}
